<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card>
          <v-layout justify-center wrap pa-2 py-4>
            <v-flex xs6>
              <v-card-title> SubCategory Slider </v-card-title>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs6 sm6 md6 text-right>
              <v-dialog v-model="dialog" max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined v-bind="attrs" v-on="on"> Add </v-btn>
                </template>
                <v-card>
                  <v-form v-model="formCategory" ref="formCategory">
                    <v-card-title>
                      <span class="headline">Add Image</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <!-- <v-col cols="12" sm="12">
                            <v-select
                              v-model="cat"
                              :items="catArray"
                              item-text="name"
                              item-value="_id"
                              item-color="#8d8d8d"
                              color="#8d8d8d"
                              outlined
                              dense
                              label="Category"
                            >
                            </v-select>
                          </v-col> -->
                          <v-col>
                            <span>Select Type</span>
                            <v-radio-group v-model="radios" mandatory>
                              <v-radio
                                label="Product"
                                :value="product"
                              ></v-radio>
                              <v-radio label="Seller" :value="seller"></v-radio>
                            </v-radio-group>
                          </v-col>
                          <v-col cols="12" sm="12" v-if="this.radios">
                            <v-select
                              v-model="seller"
                              :items="sellerArray"
                              item-text="sellerid.shopName"
                              item-value="_id"
                              item-color="#8d8d8d"
                              color="#8d8d8d"
                              outlined
                              dense
                              label="Type Seller"
                            >
                            </v-select>
                          </v-col>
                          <v-col cols="12" sm="12" v-else>
                            <v-select
                              v-model="product"
                              :items="productArray"
                              item-text="name"
                              item-value="_id"
                              item-color="#8d8d8d"
                              color="#8d8d8d"
                              outlined
                              dense
                              label="Type Product"
                            >
                            </v-select>
                          </v-col>
                          <v-flex md12 xs12 py-5>
                            <ImageCom
                              @stepper="winStepper"
                              :heading="'Upload Image'"
                              :componentType="'topimage'"
                            />
                          </v-flex>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click="dialog = false">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="!formCategory"
                        @click="categoryadd()"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-start v-if="category.length > 0">
      <v-flex v-for="(item, i) in category" :key="i" md3 pa-4>
        <v-card style="line-height: 16px">
          <v-img
            v-if="item.image"
            style="width: 100%; object-fit: contain; cursor: pointer"
            :src="baseURL + '/file/get/' + item.image"
            height="300px"
            cover
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="#FF2323"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-img
            v-else
            height="300px"
            cover
            src="./../../assets/images/noimage.png"
          ></v-img>
          <v-layout wrap justify-center px-2 py-4>
            <v-flex xs12>
              <span class="homeName"> {{ item.subcategoryId.name }} </span
              ><br /><br />
              <span
                v-if="item.productId"
                style="font-size: 13px; font-weight: bold; color: #000000"
              >
                {{ item.productId.name }}
              </span>
              <span
                v-else
                class="showLine"
                style="font-size: 13px; color: #000000"
              >
                {{ item.sellerId.sellerid.shopName }}
              </span>
            </v-flex>
            <v-flex pt-5 xl6 lg6 md6 pb-2 sm6 xs6 px-5 justify-center>
              <v-dialog v-model="item.delete" max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    class="mr-2"
                    outlined
                    block
                    v-on="on"
                    v-bind="attrs"
                    color="red"
                  >
                    Delete
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title
                    >Are you sure you want to delete this Image?</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="item.delete = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="DeleteCategory(item)"
                      >OK</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex pt-5 xl6 lg6 md6 pb-2 sm6 xs6 px-5 justify-center>
              <v-btn
                small
                class="mr-2"
                outlined
                block
                color="green"
                @click="editSlider(item)"
              >
                Edit
              </v-btn>
            </v-flex>
            <br />
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap v-else>
      <v-flex md4>
        <h1>Oops!! No Data found</h1>
      </v-flex>
    </v-layout>
    <v-dialog v-model="editdialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Team</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" v-if="editingitem.categoryId">
                <v-select
                  v-model="editingitem.categoryId._id"
                  :items="catArray"
                  item-text="name"
                  readonly
                  item-value="_id"
                  item-color="#8d8d8d"
                  color="#8d8d8d"
                  outlined
                  dense
                  label="Category"
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="12" v-if="editingitem.sellerId">
                <v-select
                  v-model="editingitem.sellerId._id"
                  :items="sellerArray"
                  item-text="sellerid.shopName"
                  item-value="_id"
                  item-color="#8d8d8d"
                  color="#8d8d8d"
                  outlined
                  dense
                  label="Type Seller"
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="12" v-if="editingitem.productId">
                <v-select
                  v-model="editingitem.productId._id"
                  :items="productArray"
                  item-text="name"
                  item-value="_id"
                  item-color="#8d8d8d"
                  color="#8d8d8d"
                  outlined
                  dense
                  label="Type Product"
                >
                </v-select>
              </v-col>
              <v-flex md12 xs12 py-5>
                <ImageCom
                  @stepper="winStepper"
                  :singleImage="editingitem.image"
                  :heading="'Upload Image'"
                  :componentType="'topimage'"
                />
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="editdialog = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="edit(editingitem)">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ImageCom from "@/components/commonComponents/singleImage";
export default {
  components: {
    ImageCom,
  },
  data() {
    return {
      headers: [
        { text: "Icon", value: "icon", sortable: false },
        { text: "Category", value: "name" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      radios: true,
      // edit: false,
      editId: "",
      dialog: false,
      addDialogbox: false,
      addDialog: false,
      deleteCategory: false,
      formCategory: false,
      categoryId: null,
      category: [],
      categoryImg: null,
      imagePreview: null,
      attachments: [],
      selectedFiles: null,
      attachmentsformData: new FormData(),
      editingitem: [],
      name: "",
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      itemsPerPage: 20,
      page: 1,
      totalpages: 0,
      ItemsCount: [20, 30, 50, 100],
      msg: "",
      showsnackbar: false,
      timeout: 3000,
      seller: "",
      sellerArray: [],
      product: "",
      productArray: [],
      cat: "",
      catArray: [],
      cId: null,
      editdialog: false,
      topimageFile: null,
      formDataCover: new FormData(),
    };
  },
  beforeMount() {
    this.getCategory();
    this.getSeller();
    // this.getCat();
    this.getProduct();
  },
  watch: {
    itemsPerPage: function () {
      this.getCategory();
    },
    // cat() {
    //   this.getSeller();
    //   this.getProduct();
    // },
  },
  methods: {
    prevpage() {
      if (this.page > 1) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page--;
        this.getCategory();
        // } else {
        //   this.page--;
        //   this.getcategory();
        // }
      }
    },
    nextpage() {
      if (this.page < this.totalpages) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page++;
        this.getCategory();
        // } else {
        //   this.page++;
        //   this.getcategory();
        // }
      }
    },
    winStepper(window_data) {
      if (window_data.type == "topimage") {
        this.topimageFile = window_data.selectedFiles;
      }
    },
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/subcategory/slider/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          subcategoryId: this.$route.query.subcategoryId,
          limit: this.itemsPerPage,
          page: this.page,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.category = response.data.data;
          this.count = response.data.totalLength;
          this.totalpages = Math.ceil(
            response.data.totalLength / this.itemsPerPage
          );

          if (response.data.length > 0) {
            this.pageStart = (response.data.page - 1) * response.data.limit + 1;
            this.pageEnd = this.pageStart + response.data.length - 1;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    // getCat() {
    //   this.appLoading = true;
    //   axios({
    //     method: "GET",
    //     url: "/category/list",
    //     headers: {
    //       token: localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       this.catArray = response.data.data;
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.msg = err.response.data.msg;
    //       this.msg = "Server Unreachable";
    //       this.showsnackbar = true;
    //     });
    // },
    getSeller() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/sellers/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          subcategoryId: this.$route.query.subcategoryId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.sellerArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    getProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          subcategoryId: this.$route.query.subcategoryId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.productArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    categoryadd() {
      this.dialog = false;
      axios({
        url: "/subcategory/slider/add",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          subcategoryId: this.$route.query.subcategoryId,
          sellerId: this.seller,
          productId: this.product,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.cId = response.data.id;
            if (this.topimageFile) {
              this.uploadImage(this.cId);
            } else {
              // this.editId = null;
              this.getCategory();
            }
            this.msg = "SubCategory Added!";
            this.showsnackbar = true;
            this.name = null;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;
      this.editdialog = true;
      this.editingitem.cat = this.editingitem.categoryId.name;
    },
    DeleteCategory(item) {
      axios({
        url: "/subcategory/slider/delete/" + item._id,
        method: "POST",

        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "SubCategory Deleted";
            this.showsnackbar = true;

            this.getCategory();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadImage(id) {
      this.formDataCover.append("image", this.topimageFile);
      axios({
        method: "POST",
        url: "/subcategory/slider/upload/image/" + id,
        data: this.formDataCover,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = "Upload Successfully";
            this.showsnackbar = true;

            this.formDataCover = new FormData();
            this.dialog = false;
            this.editdialog = false;
            this.getCategory();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.msg = "Can't Upload Cover Image.. Please Try Again Later";
          this.showSnackBar = true;
          console.log(err);
        });
    },
    // uploadattachments(id) {
    //   // var url = "";
    //   // if (this.editId) url = "/category/upload/icon/" + this.editId;
    //   // else url = "/category/upload/icon/" + this.cId;
    //   this.categoryImg = null;
    //   // this.attachmentsformData.append("images", this.attachments);
    //   axios({
    //     method: "POST",
    //     url: "/subcategory/slider/upload/image/" + id,
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //       token: localStorage.getItem("token"),
    //     },

    //     data: this.attachmentsformData,
    //     onUploadProgress: function (progressEvent) {
    //       var percentCompleted = Math.round(
    //         (progressEvent.loaded * 100) / progressEvent.total
    //       );
    //       //this.appLoading = true;
    //       // vm.uploadMsg = "Uploading " + percentCompleted + "%";
    //       if (percentCompleted == 100) {
    //         // this.appLoading = false;
    //       }
    //     },
    //   })
    //     .then((response) => {
    //       if (response.status) {
    //         this.appLoading = false;
    //         (this.dialog = false), this.getCategory();
    //         this.attachmentsformData = new FormData();
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    edit(id) {
      this.appLoading = true;
      var user = {};
      if (this.editingitem.sellerId)
        user["sellerId"] = this.editingitem.sellerId._id;
      if (this.editingitem.productId)
        user["productId"] = this.editingitem.productId._id;
      user["id"] = id._id;
      axios({
        method: "POST",
        url: "/subcategory/slider/edit",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            // this.getCategory();
            if (this.topimageFile) {
              this.uploadImage(this.cId);
            } else {
              // this.editId = null;
              this.getCategory();
            }
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    info(item) {
      this.$router.push("/addImage/category/" + item._id);
    },
  },
};
</script>
<style >
tbody tr:nth-of-type(odd) {
  background-color: rgba(28, 133, 219, 0.05);
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>



